import React, { useEffect } from "react";
import { useEventBus } from "../../util/useEventBus";
import { useConfig } from "@eis-poc/lib-discover-medical-mfes";

import {
  CTA_EVENT_TYPE,
  CTA_TRIGGER_ACTION,
  useLaunchCTA,
} from "../../hooks/useLaunchCTA";

const MerativeAssistant = () => {
  const configData = useConfig();
  const customerId = configData?.header?.userDetails?.affiliationId;

  const eventBus = useEventBus();
  const { launchCTA } = useLaunchCTA({ eventBus });

  useEffect(() => {
    if (!customerId) {
      launchCTA({
        userAction: CTA_TRIGGER_ACTION.MERATIVE_ASSISTANT_VIEW,
        type: CTA_EVENT_TYPE.GENERIC,
        component: "MerativeAssistant",
      });
    }
  }, [customerId, launchCTA]);

  return <></>;
};

export default MerativeAssistant;
